﻿import React from 'react';
import PropTypes from 'prop-types';

// b64 encode & decode taken from:
// https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings

const b64EncodeUnicode = (str) =>
    btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
        (match, p1) => String.fromCharCode(`0x${p1}`)
    ));

const b64DecodeUnicode = (str) =>
    decodeURIComponent(atob(str).split('').map((c) =>
        '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''));

const isBase64Encoded = (str) => {
    try {
        return b64EncodeUnicode(b64DecodeUnicode(str)) == str
    } catch (err) {
        return false;
    }
};

// make dom node to the raw container div accessible by inputRef prop in parent
// see https://5abc31d8be40f1556f06c4be--reactjs.netlify.com/docs/refs-and-the-dom.html
// NOTE: the react ref api changed in 16.3.0! THIS IS 16.2.0!!

const RawHtml = ({children, className = "", inputRef}) => {
    const htmlString = isBase64Encoded(children)
        ? b64DecodeUnicode(children)
        : children;

    return (<div
        ref={inputRef}
        className={className}
        dangerouslySetInnerHTML={
            { __html: htmlString.replace(/\\"/g, '"').replace('\n', '').replace('\r', '') }
        }
    />);
};

RawHtml.propTypes = {
    children: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default RawHtml;
